import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { BoldTextPipe } from './pipe/pipe';
import { AppComponent } from './app.component';
import { SurveyJobsService } from './services/surveyjobs.service';


const paths: string[] = window.location.pathname.replace("//", "/").split("/");
const appRoute: Routes = [
  { path: 'Home', component: AppComponent },
  { path: '', redirectTo: 'Home', pathMatch: 'full' },
  { path: '**', redirectTo: 'Home', pathMatch: 'full' },
  { path: 'SurveyJobs', component: AppComponent },
];

@NgModule({
  declarations: [
    AppComponent, BoldTextPipe
  ],
  imports: [
    FormsModule, BrowserModule, HttpClientModule, RouterModule.forRoot(appRoute, {}),

  ],
  providers: [SurveyJobsService, { provide: APP_BASE_HREF, useValue: paths[1].toLowerCase() === "surveyjobs" ? "/surveyjobs/" : "/" + paths[1] + "/surveyjobs/" }],
  bootstrap: [AppComponent]
})
export class AppModule { }



